import { Injectable } from '@angular/core';
import { CommandHelper, QuickCommandService } from '@app/shared/quick-commands';
import { ApplicationMaintenanceCommand } from '@app/shared/quick-commands/commands/application-maintenance.command';
import { EventSourceCommand } from '@app/shared/quick-commands/commands/event-source.command';
import { FallbackToSearchCommand } from '@app/shared/quick-commands/commands/fallback-to-search.command';
import { LogoutCommand } from '@app/shared/quick-commands/commands/logout.command';
import { ReloadLanguageCommand } from '@app/shared/quick-commands/commands/reload-language.command';
import { SortOrderCommand } from '@app/shared/quick-commands/commands/sort-order.command';
import { SwitchLanguageCommand } from '@app/shared/quick-commands/commands/switch-language.command';
import { SyncCommand } from '@app/shared/quick-commands/commands/sync.command';
import { UserPermissionsCommand } from '@app/shared/quick-commands/commands/user-permissions.command';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RegisterCommandsService {
  constructor(
    private applicationMaintenanceCommand: ApplicationMaintenanceCommand,
    private eventSourceCommand: EventSourceCommand,
    private fallbackToSearchCommand: FallbackToSearchCommand,
    private logoutCommand: LogoutCommand,
    private quickCommandService: QuickCommandService,
    private reloadLanguageCommand: ReloadLanguageCommand,
    private sortOrderCommand: SortOrderCommand,
    private switchLanguageCommand: SwitchLanguageCommand,
    private syncCommand: SyncCommand,
    private userPermissionsCommand: UserPermissionsCommand
  ) {}

  initialize(): void {
    this.quickCommandService.add(this.applicationMaintenanceCommand.getCommand());
    this.quickCommandService.add(this.fallbackToSearchCommand);
    this.quickCommandService.add(this.logoutCommand);
    this.quickCommandService.add(this.sortOrderCommand);
    this.quickCommandService.add(this.switchLanguageCommand);
    this.quickCommandService.add(this.syncCommand);
    this.quickCommandService.add(
      CommandHelper.commandGroup({
        commands: [this.eventSourceCommand, this.userPermissionsCommand],
        icon: 'far fa-lightbulb',
        label: 'quickCommands.commands.status.label',
        name: 'status',
      })
    );

    if (environment.production === false) {
      this.quickCommandService.add(this.reloadLanguageCommand);
    }
  }
}
